<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Role Management Detail">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="functionInfos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Function Info" id="input-" size="sm" :model.sync="model.functionInfoId"   :selected="model.functionInfo != null ? model.functionInfo.name : ''" @input="getFunctionInfos" />
				<b-form-group id="fieldset-allow-create" label-cols-sm="4" label-cols-lg="3" label="Allow Create" label-for="input-allow-create">
						<b-form-checkbox id="input-allow-create" v-model="model.allowCreate"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-read" label-cols-sm="4" label-cols-lg="3" label="Allow Read" label-for="input-allow-read">
						<b-form-checkbox id="input-allow-read" v-model="model.allowRead"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-update" label-cols-sm="4" label-cols-lg="3" label="Allow Update" label-for="input-allow-update">
						<b-form-checkbox id="input-allow-update" v-model="model.allowUpdate"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-delete" label-cols-sm="4" label-cols-lg="3" label="Allow Delete" label-for="input-allow-delete">
						<b-form-checkbox id="input-allow-delete" v-model="model.allowDelete"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-show-in-menu" label-cols-sm="4" label-cols-lg="3" label="Show In Menu" label-for="input-show-in-menu">
						<b-form-checkbox id="input-show-in-menu" v-model="model.showInMenu"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-download" label-cols-sm="4" label-cols-lg="3" label="Allow Download" label-for="input-allow-download">
						<b-form-checkbox id="input-allow-download" v-model="model.allowDownload"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-print" label-cols-sm="4" label-cols-lg="3" label="Allow Print" label-for="input-allow-print">
						<b-form-checkbox id="input-allow-print" v-model="model.allowPrint"></b-form-checkbox>
					</b-form-group>
				<b-form-group id="fieldset-allow-upload" label-cols-sm="4" label-cols-lg="3" label="Allow Upload" label-for="input-allow-upload">
						<b-form-checkbox id="input-allow-upload" v-model="model.allowUpload"></b-form-checkbox>
					</b-form-group>
			</b-col>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}
</style> 
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import RoleManagementDetail from '@/models/RoleManagement/RoleManagementDetail';
import RoleManagementDetailFilter from '@/filters/RoleManagement/RoleManagementDetailFilter';

import RoleManagement from '@/models/RoleManagement/RoleManagement';
import RoleManagementFilter from '@/filters/RoleManagement/RoleManagementFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import FunctionInfo from '@/models/Core/FunctionInfo';
import FunctionInfoFilter from '@/filters/Core/FunctionInfoFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {AppInputComboboxAutocomplete,PopupRouterView,},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			functionInfos : [],
			isBusy: false,
		}
	},
	methods : {
		getRoleManagementDetail : async function(id) {
			this.isBusy = true;
			RoleManagementDetail.getData(this, id).then(result => { this.model = result; this.isBusy = false }).catch(error => { this.isBusy = false; });
		},
		getFunctionInfos : async function(input) {
			let filter = new FunctionInfoFilter();
			if (input != undefined) {
				filter.name = input;
			}
			FunctionInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.functionInfos = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.$emit("addButtonMethod", modalEvent, this.model); 
			}
		},
		resetModal() {
			this.$emit('resetMethod');
		},
	},
	beforeMount() {
		this.getFunctionInfos();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getRoleManagementDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getFunctionInfos();
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
